// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3BCPX","bigColWidth":"Table_bigColWidth__Owrop","biggerColWidth":"Table_biggerColWidth__Hn-zL","row":"Table_row__2VdFP","col":"Table_col__362mf"};